import React, { useMemo } from 'react';
import { Tooltip } from '@mui/material';
import { Error, CheckCircle } from '@mui/icons-material';
import type { AuditDynamicFormFieldIconProps } from '../../types/auditFormTypes';

const AuditDynamicFormFieldIcon: React.FC<AuditDynamicFormFieldIconProps> = React.memo(({
  ticket,
  fieldType,
}) => {
  const icon = useMemo(() => {
    if (!ticket) {
      return null;
    }

    if (fieldType === 'range' && ticket.rangeMismatch && !ticket.rangeAccepted) {
      return (
        <Tooltip title={ticket.rangeTooltip || 'Range mismatch with previous audit'}>
          <Error sx={{ fontSize: 10, color: '#f44336', height: '10px', maxHeight: '10px', width: '10px', maxWidth: '10px' }} />
        </Tooltip>
      );
    }

    if (fieldType === 'range' && ticket.rangeAccepted && ticket.rangeMismatch) {
      return (
        <Tooltip title={`Range accepted :- ${ticket.rangeTooltip}`}>
          <CheckCircle sx={{ fontSize: 10, color: '#4caf50', height: '10px', maxHeight: '10px', width: '10px', maxWidth: '10px' }} />
        </Tooltip>
      );
    }

    if (fieldType === 'range-end') {
      const [, rangeEnd = ''] = String(ticket.range || '').split('-');

      if (rangeEnd === 'END') {
        return (
          <Tooltip title="Pack completed">
            <Error sx={{ fontSize: 10, color: '#ffa500', height: '10px', maxHeight: '10px', width: '10px', maxWidth: '10px' }} />
          </Tooltip>
        );
      }
    }

    if ((fieldType === 'game' || fieldType === 'pack') && ticket.haveError) {
      return (
        <Tooltip title={ticket.errorMessage || 'Error detected'}>
          <Error sx={{ fontSize: 10, color: '#f44336', height: '10px', maxHeight: '10px', width: '10px', maxWidth: '10px' }} />
        </Tooltip>
      );
    }

    return null;
  }, [fieldType, ticket]);

  return icon;
});

AuditDynamicFormFieldIcon.displayName = 'AuditDynamicFormFieldIcon';

export default AuditDynamicFormFieldIcon;
